import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  queryTask: (params: {
    page: number;
    pageSize: number;
    sortField?: string;
    sortOrder?: string;
    status?: string;
  }) => defHttp.get({ url: `/aiad/pod/tasks`, params }),

  addTask: (params: {
    image?: string;
    file?: string;
    needMatting?: boolean;
    needGenerate?: boolean;
    ar?: string;
    mockupParams?: any;
    generateType?: 'ID' | 'MJ';
    horizontal?: boolean;
  }) => defHttp.post({ url: `/aiad/pod/tasks`, params }),

  handleTask: (id: string | number, params?: { result: number }) =>
    defHttp.post({ url: `/aiad/pod/tasks/${id}`, params }),

  autoGoods: (params) => defHttp.post({ url: `/cdp/auto-goods`, params }),
  getAutoGoods: (params?) => defHttp.get({ url: `/cdp/auto-goods`, params }),
  exportGoods: (params) => defHttp.post({ url: '/cdp/export-goods', params }),

  updateGoods: (params) => defHttp.put({ url: '/cdp/auto-goods', params }),

  /** POD 商品品类（一级 + 二级） */
  getCategoryNew: () => defHttp.get({ url: '/aiad/pod/category-new' }),

  /** 查询宠物服饰列表 */
  getPetClothes: (params?: { type?: string }) =>
    defHttp.get<
      Array<{
        id: number;
        image: string;
        prompt: string;
        status: string;
        type: string;
        createBy?: string;
        createTime?: string;
        modifyBy?: string;
        modifyTime?: string;
      }>
    >({
      url: '/aiad/pod/pet-clothes',
      params,
    }),

  /** 保存印花修订记录（反转 / 描边） */
  savePrintRevision: (params: {
    /** 无滤镜印花截图（originUrl） */
    image: string;
    /** 用户使用的滤镜方法 */
    filter: 'invert' | 'no_process' | 'outline_black' | 'outline_white';
    /** 描边粗细（仅描边时） */
    strokeWidth?: number;
    /** 当前套图地址 */
    batchUrl?: string;
  }) => defHttp.post({ url: '/aiad/pod/print-revision', params }),

  /** 营销日历列表 */
  getPodHotTrendCalendars: () =>
    defHttp.get<HotTrendCalendarItem[]>({ url: '/aiad/pod/hot-trend/calendars' }),

  /** 热卖品列表 */
  getPodHotTrendHotProducts: () =>
    defHttp.get<HotTrendHotProductItem[]>({ url: '/aiad/pod/hot-trend/hot-products' }),

  /** 套图模版-热卖（按样机类型） */
  getPodHotTrendHotTemplates: (params: { mockupType: 'lingtu' | 'psd' }) =>
    defHttp.get<HotTrendHotTemplateItem[]>({
      url: '/aiad/pod/hot-trend/hot-templates',
      params,
    }),

  /** 图案趋势列表 */
  getPodHotTrendPatternTrends: (params?: {
    page?: number;
    pageSize?: number;
    sortField?: string;
    sortOrder?: string;
  }) =>
    defHttp.get<HotTrendPatternTrendsResult>({
      url: '/aiad/pod/hot-trend/pattern-trends',
      params,
    }),

  /** 累积充值解锁概况 */
  getPodHotTrendRechargeSummary: () =>
    defHttp.get<HotTrendRechargeSummary>({ url: '/aiad/pod/hot-trend/recharge-summary' }),
});

export type HotTrendCalendarStage = 'planning' | 'preparing' | 'burst' | 'ended';

export interface HotTrendCalendarCase {
  materialImages: string[];
  resultImages: string[];
  taskParams: string;
  taskType: string;
  taskUrl: string;
}

export interface HotTrendCalendarItem {
  cases: HotTrendCalendarCase[];
  endDate: string;
  guideUrl: string;
  id: number;
  name: string;
  stage: HotTrendCalendarStage;
  startDate: string;
}

export interface HotTrendHotTemplateItem {
  hotTemplateId: number;
  meta: Record<string, unknown>;
  mockupType: 'lingtu' | 'psd';
  name: string;
  preview: string;
  previews: string[];
}

export interface HotTrendHotProductItem {
  categoryName: string;
  cost: number;
  craft: string;
  hotTemplateId: number;
  id: number;
  meta: Record<string, unknown>;
  /** 热度标识文案，为空时卡片不展示 */
  popularity?: string;
  preview: string;
  sellingPoint?: string;
  shippingCycle: string;
  shippingPlace: string;
  suggestedPrice: number;
}

export interface HotTrendPatternTrendItem {
  cover: string;
  id: number;
  imageCount: number;
  images: string[];
  publishTime: string;
  sourceUrl: string;
  title: string;
}

export interface HotTrendPatternTrendsResult {
  items: HotTrendPatternTrendItem[];
  pages: number;
  total: number;
}

export interface HotTrendRechargeSummary {
  rechargeAmount: number;
  unlockThreshold: number;
  unlocked: boolean;
}
